// Scope codenames returned by GET /api/auth/user/ (fms_inherited. prefix already stripped by backend).
// Import these constants everywhere — never hardcode scope strings in components or hooks.
// Use ScopeCode as the type for any scope parameter to catch invalid strings at compile time.

export const READ_CLIENT_MASTER = 'read_client_master';
export const WRITE_CLIENT_MASTER = 'write_client_master';
export const CLIENT_MASTER_EXPORT = 'client_master_export';
export const READ_GENERAL_MASTERS = 'read_general_masters';
export const WRITE_GENERAL_MASTERS = 'write_general_masters';
export const ORDERS_MANAGEMENT = 'orders_management';
export const WRITE_ORDERS_AND_RECOMMENDATIONS = 'write_orders_and_recommendations';
export const HOLDINGS_AND_DATA = 'holdings_and_data';
export const FINANCIAL_MANAGEMENT = 'financial_management';
export const PORTFOLIO_TRANSACTIONS = 'portfolio_transactions';
export const FEES_AND_DISTRIBUTOR = 'fees_and_distributor';
export const PERFORMANCE = 'performance';
export const ANALYTICS = 'analytics';
export const TRADE_SUGGESTIONS = 'trade_suggestions';
export const KITE_CONNECT = 'kite_connect';
export const USER_ROLE_MANAGEMENT = 'user_role_management';
export const PORTFOLIO_QA = 'portfolio_qa';
export const OPERATIONS_CHECKLIST = 'operations_checklist';
export const SOA_MANAGEMENT = 'soa_management';
export const SOA_SEND_EMAIL = 'soa_send_email';
export const COMPANY_CIO_NOTE = 'company_cio_note';

export type ScopeCode =
  | typeof READ_CLIENT_MASTER
  | typeof WRITE_CLIENT_MASTER
  | typeof CLIENT_MASTER_EXPORT
  | typeof READ_GENERAL_MASTERS
  | typeof WRITE_GENERAL_MASTERS
  | typeof ORDERS_MANAGEMENT
  | typeof WRITE_ORDERS_AND_RECOMMENDATIONS
  | typeof HOLDINGS_AND_DATA
  | typeof FINANCIAL_MANAGEMENT
  | typeof PORTFOLIO_TRANSACTIONS
  | typeof FEES_AND_DISTRIBUTOR
  | typeof PERFORMANCE
  | typeof ANALYTICS
  | typeof TRADE_SUGGESTIONS
  | typeof KITE_CONNECT
  | typeof USER_ROLE_MANAGEMENT
  | typeof PORTFOLIO_QA
  | typeof OPERATIONS_CHECKLIST
  | typeof SOA_MANAGEMENT
  | typeof SOA_SEND_EMAIL
  | typeof COMPANY_CIO_NOTE;
